function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import merge from 'lodash/merge';
import { legend, mergeOptions, tooltip, xAxis, yAxis } from '../utils/commons';
import Chart from '../chart';
import tooltipXPosition from '../utils/tooltip_x_position';
import mergeRefs from 'react-merge-refs';
var barOptions = _ref => {
  var {
    group,
    theme,
    chartRef,
    tickRef
  } = _ref;
  var selectedTick = tickRef;
  var borderRadius = group ? 2 : theme.borderRadius2;
  if (theme.borderRadius2 === '0px') {
    borderRadius = 0;
  }
  return {
    chart: {
      type: 'bar',
      // @ts-expect-error expects a list
      spacing: 20,
      marginRight: 50
    },
    legend: legend({
      group,
      theme
    }),
    plotOptions: {
      bar: _objectSpread(_objectSpread({
        groupPadding: 0.2,
        pointPadding: 0.2,
        // @ts-expect-error property not present?
        borderRadiusTopLeft: borderRadius,
        borderRadiusTopRight: borderRadius,
        borderWidth: 0
      }, !group && {
        pointWidth: 16
      }), {}, {
        // Sets and unsets the label color on hover
        point: {
          events: {
            mouseOver: e => {
              if (!chartRef.current) {
                return;
              }

              // @ts-expect-error category is there
              var {
                category
              } = e.target;
              var {
                ticks
              } = chartRef.current.chart.xAxis[0];
              var foundTick = Object.values(ticks).find(tick => {
                var _tick$label;
                // @ts-expect-error textStr is there
                return tick.pos > -1 && category === ((_tick$label = tick.label) === null || _tick$label === void 0 ? void 0 : _tick$label.textStr);
              });
              if (foundTick !== null && foundTick !== void 0 && foundTick.label) {
                selectedTick.current = foundTick;
                foundTick.label.css({
                  color: theme.palette.foreground.default
                });
              }
            },
            mouseOut: () => {
              if (!selectedTick.current) {
                return;
              }
              var {
                current: tick
              } = selectedTick;
              if (tick && tick.label) {
                tick.label.css({
                  color: theme.palette.foreground.light
                });
                selectedTick.current = null;
              }
            }
          }
        }
      })
    },
    subtitle: {
      text: undefined
    },
    tooltip: merge(tooltip({
      theme
    }), {
      positioner(labelWidth, labelHeight, point) {
        var {
          chart
        } = this;
        return {
          x: tooltipXPosition(chart),
          y: point.plotY + this.chart.plotTop - labelHeight / 2
        };
      }
    }),
    xAxis: merge(xAxis({
      group,
      theme
    }), {
      labels: {
        x: -8
      }
    }),
    yAxis: merge(yAxis({
      theme
    }), {
      title: {
        y: 8
      }
    })
  };
};
var Bar = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  var {
    options,
    theme
  } = _ref2;
  var chartRef = React.useRef(null);
  var tickRef = React.useRef(null);
  var handleRef = mergeRefs([ref, chartRef]);
  var chartOptions = React.useMemo(() => {
    var {
      series
    } = options;
    var group = series && series.length > 1;
    var mergedOptions = mergeOptions(barOptions({
      group,
      theme,
      chartRef,
      tickRef
    }), options);
    var hasVerticalLegend = mergedOptions.legend && mergedOptions.legend.layout === 'vertical' && mergedOptions.legend.align === 'right';
    if (hasVerticalLegend) mergedOptions.chart.marginRight = undefined;
    return mergedOptions;
  }, [options, theme]);
  return /*#__PURE__*/React.createElement(Chart, {
    immutable: true,
    options: chartOptions,
    ref: handleRef,
    theme: theme
  });
});
Bar.displayName = 'Bar';
export default Bar;